module.exports = __webpack_public_path__ + "static/media/delta.8c9f099e.svg";